<div class="message-container">
    <div *ngIf="!isOwner" class="avatar-container">
        <div class="avatar-wrapper">
            <app-user-profile-avatar [user]="data.sender.name"/>
        </div>
    </div>
    <div class="message-content">
        <div *ngIf="!isOwner" class="user-name-wrapper">
            <span class="user-name">{{data.sender.name}}</span>
        </div>
        <div class="message-wrapper" [ngClass]="{'message-owner': isOwner}">
            <p class="message-text">
                {{data.text}}
            </p>
        </div>
        <div class="time-wrapper">
            <span class="time">{{data.time | date : 'hh:mm a'}}</span>
        </div>
    </div>
</div>
